import React from 'react'
import MainTab from '@/pages/MainTab'
import OverView from '@/pages/main/Overview'
import StationList from '@/pages/main/StationList'
import StationTab from '@/pages/StationTab'
import Station from '@/pages/site/Station'
import Message from '@/pages/site/Message'
import Chart from '@/pages/site/Chart'
import StationDetail from '@/pages/site/StationDetail'
import DeviceList from '@/pages/site/DeviceList'
import Inverter from '@/pages/site/Inverter'
import Battery from '@/pages/site/inverter/Battery'
import Basic from '@/pages/site/inverter/Basic'
import Gen from '@/pages/site/inverter/Gen'
import Grid from '@/pages/site/inverter/Grid'
import Load from '@/pages/site/inverter/Load'
import Solar from '@/pages/site/inverter/Solar'
import Setting from '@/pages/site/inverter/Setting'
import Login from '@/pages/login/Login'
import Register from '@/pages/login/Register'
import { Navigate } from 'react-router-dom'
import { Routes } from '@/type/publicPropsType'

export default [
  // {
  //   path: "/",
  //   element: <OverView />,
  // },
  // {
  //   path: "/sitelist",
  //   element: <StationLists />,
  // },
  {
    path: '/',
    element: <MainTab />,
    children: [
      {
        path: 'overview',
        element: <OverView />,
        meta: {
          title: 'menu.overview',
        },
      },
      {
        path: 'sitelist',
        element: <StationList />,
        meta: {
          title: 'menu.siteList',
        },
      },
      {
        path: '/',
        element: <Navigate to='/sitelist' />,
      },
    ],
  },
  {
    path: '/site/:id',
    element: <StationTab />,
    children: [
      {
        path: 'devicelist',
        element: <DeviceList />,
        meta: {
          title: 'menu.deviceList',
        },
      },
      {
        path: 'chart',
        element: <Chart />,
        meta: {
          title: 'menu.chart',
        },
      },
      {
        path: 'sitedetail',
        element: <StationDetail />,
        meta: {
          title: 'menu.siteDetail',
        },
      },
      {
        path: 'message',
        element: <Message />,
        meta: {
          title: 'menu.message',
        },
      },
      {
        path: 'main',
        element: <Station />,
        meta: {
          title: 'menu.site',
        },
      },
      {
        path: 'inverter/:deviceId',
        element: <Inverter />,
        children: [
          {
            path: 'battery',
            element: <Battery />,
            meta: {
              title: 'menu.battery',
            },
          },
          {
            path: 'basic',
            element: <Basic />,
            meta: {
              title: 'menu.basic',
            },
          },
          {
            path: 'gen',
            element: <Gen />,
            meta: {
              title: 'menu.gen',
            },
          },
          {
            path: 'grid',
            element: <Grid />,
            meta: {
              title: 'menu.grid',
            },
          },
          {
            path: 'load',
            element: <Load />,
            meta: {
              title: 'menu.load',
            },
          },
          {
            path: 'solar',
            element: <Solar />,
            meta: {
              title: 'menu.solar',
            },
          },
          {
            path: 'setting',
            element: <Setting />,
            meta: {
              title: 'menu.setting',
            },
          },
          {
            path: '*',
            element: <Navigate to='solar' />,
          },
          {
            path: '',
            element: <Navigate to='solar' />,
          },
        ],
      },
      {
        path: '*',
        element: <Navigate to='main' />,
      },
      {
        path: '',
        element: <Navigate to='main' />,
      },
    ],
  },
  {
    path: '/login',
    element: <Login />,
    meta: {
      title: 'menu.login',
    },
  },
  {
    path: '/register',
    element: <Register />,
    meta: {
      title: 'menu.register',
    },
  },
  {
    path: '*',
    element: <Navigate to='/login' />,
  },
] as Routes[]
